import { NewestPage } from './NewestPage'
import { withNewestPage } from './withNewestPage'

const Connected = withNewestPage(NewestPage)

export { Connected as NewestPage }
